<div class="card bg-base-100 mb-5">
  <div class="card-body">
    <div class="flex flex-col gap-[15px]">
      <div class="flex flex-row justify-between">
        <div class="cavex-card-header">
          <ng-content select="[title]"></ng-content>
        </div>
        <div class="flex flex-col items-end gap-[15px]">
          <ng-content select="[buttons]"></ng-content>

          <ng-content select="[filter-bar]"></ng-content>
        </div>
      </div>
      <ng-content select="[table]"></ng-content>
      <div class="flex justify-center">
        <ng-content select="[pagination]"></ng-content>
      </div>
    </div>
  </div>
</div>
